@if (isBrowser) {
<div>
<app-breadcrumb [breadcrumb]="breadcrumb" class="d-none d-lg-block d-xl-block"></app-breadcrumb>
<!-- <app-incomplete-info-warning></app-incomplete-info-warning> -->
<section class="cart-section section-b-space pt-0">
  <div class="container-fluid-lg">
    <div class="d-lg-none d-xl-none pt-3 fs-5 fw-bold">
      Giỏ hàng
    </div>

      <!-- MODAL -->
      <app-warning-price-chance-modal
        #priceModal
        [items]="priceChangedItems"
        (accept)="onAcceptChangePrice()"
        (close)="onCloseModal()">
      </app-warning-price-chance-modal>

      <!-- CART HISTORY MODAL -->
      <app-cart-history-modal
        #cartHistoryModal
        (restored)="onCartRestored()">
      </app-cart-history-modal>

      <!-- VOUCHER INELIGIBLE WARNING MODAL -->
      <app-voucher-ineligible-modal
        #voucherIneligibleModal>
      </app-voucher-ineligible-modal>

    <ng-container *ngIf="skeletonLoader && !cart.items.length else hasData">
      <div class="d-flex justify-content-between">
        <div class="col-8">
          <div *ngFor="let item of skeletonItems">
            <div class="skeleton-div">
              <div class="product-box skeleton-box bg-transparent">
                <div class="skeleton-cart">
                  <div class="skeleton__p" style="height: 60px;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 product-box">
          <div class="skeleton-cart skeleton__p" style="height: 30px;"></div>
          <div class="skeleton-cart skeleton__p" style="height: calc(100% - 45px);"></div>
        </div>
      </div>
    </ng-container>
    <ng-template #hasData>
      <div class="row g-xl-3 g-sm-4 g-3 m-0" *ngIf="user">
        <div class="col-xxl-8 col-xl-8 p-0">
          <div class="d-grid gap-4 pb-3">
            <div class="div-section">
              <div class="p-3 d-flex justify-content-between border-bottom">
                <h4 class="fw-medium">Thông tin nhận hàng</h4>
              </div>
              <div class="p-3 d-flex border-bottom" *ngIf="addresses.length > 0">
                <ul class="d-flex gap-3" style="width: -webkit-fill-available;">
                  <li class="div-radio w-100">
                    <input class="form-check-input" type="radio" name="rdAddress" id="rdAddress"
                      [checked]="selectedAddressId == addresses[0].id" (change)="selectAddress(0)" />
                    <label class="form-check-label ps-3 w-75" for="rdAddress">
                      <ul class="d-grid gap-3">
                        <li class="d-flex gap-3">
                          <img src="assets/svg/cart/user-alt.svg" width="20" height="20"  loading="lazy" />
                          <h5>{{ defaultAddress.receiverName }}</h5>
                        </li>
                        <li class="d-flex gap-3">
                          <img src="assets/svg/cart/phone.svg" width="20" height="20"  loading="lazy" />
                          <h5>{{ defaultAddress.receiverPhone }}</h5>
                        </li>
                        <li class="d-flex gap-3">
                          <img src="assets/svg/cart/location-pin.svg" width="20" height="20"  loading="lazy" />
                          <h5 *ngIf="defaultAddress.provinceV2; else addressDefaultV1">
                            {{ defaultAddress.address }}, {{ defaultAddress.provinceV2.name }},
                            {{ defaultAddress.provinceV2.wards[0].name }}
                          </h5>
                          <ng-template #addressDefaultV1>
                            <h5>
                              {{ defaultAddress.address }}, {{ defaultAddress.province!.name }},
                              {{ defaultAddress.province!.districts[0].name }},
                              {{ defaultAddress.province!.districts[0].wards[0].name }}
                            </h5>
                          </ng-template>
                        </li>
                      </ul>
                    </label>
                  </li>
                </ul>
                <button class="bg-transparent border-0 m-auto mt-0" (click)="onEditAddress(defaultAddress)">
                  <img src="assets/svg/cart/pen-line.svg" style="width: 24px;"  loading="lazy" />
                </button>
              </div>
              <div class="p-3">
                <button class="bg-transparent border-0 d-flex gap-1 align-items-center" style="color: var(--theme-color);" (click)="addAddress()" data-cta="cart.address_add" data-cta-loc="cart">
                  <img src="assets/svg/cart/plus-circle.svg" style="width: 20px;"  loading="lazy" />
                  Thêm địa chỉ mới
                </button>
              </div>
            </div>
            <div class="d-grid p-3 div-section" *ngIf="addresses.length > 1">
              <button class="d-flex justify-content-between align-items-center bg-white border-0 ps-0"
                (click)="showMore()" data-cta="cart.address_change" data-cta-loc="cart">
                <h4 class="fw-medium">Chọn địa chỉ giao hàng khác</h4>
                <img class="{{showMoreArress ? 'arrow-up' : 'arrow-down'}}" src="assets/svg/cart/angle-down.svg"  loading="lazy" />
              </button>
              <div class="div-section" *ngIf="showMoreArress && addresses.length > 0">
                <div *ngFor="let address of addresses; let i = index">
                  <div *ngIf="i > 0 && address.status != 0">
                    <ul class="py-3 {{ (i > 0 && i < addresses.length - 1) ? 'border-bottom' : '' }} d-flex gap-3">
                      <li class="div-radio w-100">
                        <input class="form-check-input" type="radio" name="rdAddress" id="rdAddress{{i}}"
                          [checked]="selectedAddressId == address.id" (change)="selectAddress(i)" />
                        <label class="form-check-label ps-3 w-75" for="rdAddress{{i}}">
                          <ul class="d-grid gap-3">
                            <li class="d-flex gap-3">
                              <img src="assets/svg/cart/user-alt.svg"  loading="lazy" />
                              <h5>{{ address.receiverName }}</h5>
                            </li>
                            <li class="d-flex gap-3">
                              <img src="assets/svg/cart/phone.svg"  loading="lazy" />
                              <h5>{{ address.receiverPhone }}</h5>
                            </li>
                            <li class="d-flex gap-3">
                              <img src="assets/svg/cart/location-pin.svg"  loading="lazy" />
                              <h5 *ngIf="address.provinceV2; else addressV1">
                                {{ address.address }}, {{ address.provinceV2.name }},
                                {{ address.provinceV2.wards[0].name }}
                              </h5>
                              <ng-template #addressV1>
                                <h5>
                                  {{ address.address }}, {{ address.province!.name }},
                                  {{ address.province!.districts[0].name }},
                                  {{ address.province!.districts[0].wards[0].name }}
                                </h5>
                              </ng-template>
                            </li>
                          </ul>
                        </label>
                      </li>
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!-- PRICE CHANGE WARNING -->
          <div class="price-change-warning" *ngIf="priceChangedItems.length">

            <div class="warning-header">
              <div class="left">
                <img src="assets/images/svg/warning.svg" alt="warning" loading="lazy" />
                <span class="text">
                  <strong>Chú ý:</strong>
                  Có {{ priceChangedItems.length }} sản phẩm thay đổi giá so với lúc được thêm vào giỏ hàng
                </span>
              </div>

              <div class="right" (click)="togglePriceDetail()" data-cta="cart.price_detail" data-cta-loc="cart">
                <span class="text">Xem chi tiết</span>
                <i class="ri-arrow-down-s-line" [class.rotate]="showPriceChangeDetail"></i>
              </div>
            </div>

            <div class="warning-detail" *ngIf="showPriceChangeDetail">
              <div
                class="item"
                *ngFor="let item of priceChangedItems"
                (click)="goToProduct(item.slug)"
              >

                <!-- LEFT -->
                <div class="left">
                  <img [src]="item.imgUrl" alt="{{ item.name }}"  loading="lazy" />

                  <!-- NAME DESKTOP -->
                  <span class="name name-desktop">
                  {{ item.name }}
                </span>
                </div>

                <!-- RIGHT -->
                <div class="right">

                  <!-- NAME MOBILE -->
                  <div class="name name-mobile">
                    {{ item.name }}
                  </div>

                  <div class="price-row old">
                    <span class="label">Giá cũ</span>
                    <span class="value">{{ item.oldPrice | currencySymbol }}</span>
                  </div>

                  <div
                    class="price-row new"
                    [class.up]="item.differencePriceAmount > 0"
                    [class.down]="item.differencePriceAmount < 0"
                  >
                    <span class="label">Giá mới</span>
                    <span class="value">{{ item.newPrice | currencySymbol }}</span>
                  </div>

                  <div
                    class="price-row change"
                    [class.up]="item.differencePriceAmount > 0"
                    [class.down]="item.differencePriceAmount < 0"
                  >
                    <span class="arrow">
                      <img
                        *ngIf="item.differencePriceAmount > 0"
                        src="assets/images/svg/trend-up.svg"
                        alt="up"
                      />
                      <img
                        *ngIf="item.differencePriceAmount < 0"
                        src="assets/images/svg/trend-down.svg"
                        alt="down"
                       loading="lazy" />
                    </span>

                    <span class="text">
                      {{ item.differencePriceAmount > 0 ? 'Tăng' : 'Giảm' }}
                      {{ getAbsPrice(item.differencePriceAmount) | currencySymbol }}
                    </span>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!-- <div class="cart-table div-section px-0">
            <div class="d-md-none d-lg-none d-xl-none d-xxl-none d-flex align-items-center px-3"
              style="gap: 12px;">
              <ng-container *ngTemplateOutlet="giftMobile"></ng-container>
            </div>
            <div class="d-flex justify-content-between align-items-center pb-3 px-3">
              <div class="d-flex align-items-center gap-3">
                <div class="d-none d-md-flex d-lg-flex d-xl-flex d-xxl-flex gap-3">
                  <ng-container *ngTemplateOutlet="gift"></ng-container>
                </div>
              </div>
            </div>
            <div
              class="d-none d-lg-flex d-xl-flex d-xxl-flex align-items-center fw-bold px-3 py-4 border-bottom border-top">
              <div class="product-detail col-7">Quà đã đổi</div>
              <div class="col-5 d-flex justify-content-end align-items-center pe-3 gap-3">
                <div class="col-7 quantity d-none d-xl-flex d-lg-flex mx-0 my-auto justify-content-end px-3">Số lượng
                </div>
                <div class="col-5 subtotal d-none d-xl-flex d-lg-flex mx-0 my-auto justify-content-end">Thành tiền</div>
              </div>
            </div>
            <ng-container *ngIf="cart.giftItems.length > 0 else noGifts">
              <div *ngFor="let gift of cart.giftItems" class="d-flex flex-column m-3 border rounded shadow-sm">
                <div class="d-flex align-items-center border-bottom gap-3">
                  <div class="flex-grow-1 ps-3">
                    <a class="theme-color">{{ gift.name }}</a>
                  </div>
                  <div class="d-flex justify-content-end p-3 border-start">
                    <button class="border-0 bg-none p-0" (click)="removeGift(gift)">
                      <img src="assets/svg/cart/trash.svg"  loading="lazy" />
                    </button>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="product-detail col-lg-7 col-xl-7 col-xxl-7 col-md-12 col-xs-12 my-auto mx-0 p-3 col-12">
                    <div class="product border-0 d-flex">
                      <div class="d-flex align-items-center gap-3">
                        <img [src]="gift.imageUrls?.[0]" class="img-fluid" alt="{{ gift.name }}"
                          title="{{ gift.name }}"  loading="lazy" />
                        <div class="d-flex d-lg-none d-xl-none d-xxl-none flex-column gap-3">
                          <div class="d-lg-none d-xl-none d-flex gap-3 align-items-center">
                            <app-counter [isGift]="true" [giftItem]="gift"></app-counter>
                            <div class="d-none d-lg-block d-xl-block d-xxl-block w-100 mt-2">
                              <app-button-combo [containerStyle]="'s'" [flexDirection]="'column'" [btnStyte]="{'width': '155px'}"></app-button-combo>
                            </div>
                            <div class="d-lg-none d-xl-none d-xxl-none w-100 my-2">
                              <app-button-combo [containerStyle]="'s'" [flexDirection]="'column'" [btnStyte]="{'width': '155px'}"></app-button-combo>
                            </div>
                          </div>
                          <div class="d-lg-none d-xl-none d-flex gap-3 align-items-center">
                            Thành tiền
                            <b class="theme-color">{{ gift.cost | currencySymbol }}</b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-none d-lg-flex d-xl-flex d-flex justify-content-end flex-grow-1 col-lg-5 col-xl-5 col-xxl-5 col-md-12 col-xs-12 p-0">
                    <div class="col-7 my-auto mx-0 px-3">
                      <div class="product-box quantity-price div-col justify-content-end">
                        <div class="cart_qty">
                          <div class="input-group justify-content-center">
                            <app-counter [isGift]="true" [giftItem]="gift"></app-counter>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-5 my-auto mx-0 px-3">
                      <div class="quantity-price div-col justify-content-end">
                        <div class="cart_qty">
                          <div class="input-group justify-content-center">
                            <span class="fw-bold theme-color">{{ gift.cost | currencySymbol }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #noGifts>
              <div class="d-flex justify-content-center align-items-center pt-5">
                <span class="text-content" style="font-size: 14px; line-height: 120%; color: #868686;">Giỏ quà tặng hiện
                  đang trống. Hãy sử dụng xu đổi lấy quà ngay!</span>
              </div>
            </ng-template>
          </div> -->
          <div class="d-flex justify-content-end align-items-center gap-2 pb-3 d-flex d-lg-none"
               style="cursor: pointer;" (click)="openCartHistoryModal()" data-cta="cart.history_open" data-cta-loc="cart">
            <img alt="Icon Lịch sử" src="assets/svg/cart/cart-history-icon.svg" style="width: 20px;"  loading="lazy" />
            <div class="cart-history-label">Khôi phục giỏ hàng</div>
          </div>

          <div class="cart-table div-section px-0">
            <div class="d-flex align-items-center pb-3 px-3 gap-3">
              <div class="d-flex gap-3 align-items-center">
                <input class="checkbox_animated chk-all m-0" [disabled]="!cart.items.length"
                  [checked]="isAllCartItemsSelected" type="checkbox" (click)="checkAll()" />
                Chọn tất cả ({{ selected }}/{{ cart.items.length }})
              </div>
              <div class="div-del">
                Xóa sản phẩm đã chọn
                <button class="border-0 bg-none">
                  <img src="assets/svg/cart/trash.svg" (click)="deleteSelectedItems()"  loading="lazy" />
                </button>
              </div>
              <div class="d-none d-lg-flex align-items-center gap-2 ms-auto"
                   style="cursor: pointer;"
                   (click)="openCartHistoryModal()" data-cta="cart.history_open" data-cta-loc="cart">
                <img alt="Icon Lịch sử"
                     src="assets/svg/cart/cart-history-icon.svg"
                     style="width: 20px;"  loading="lazy" />
                <div class="cart-history-label">Khôi phục giỏ hàng</div>
            </div>
            </div>
            <div class="table-responsive">
              <div
                class="d-none d-lg-flex d-xl-flex d-xxl-flex align-items-center fw-bold px-3 py-4 border-bottom border-top">
                <div class="product-detail col-4">Tên sản phẩm</div>
                <div class="col-8 d-flex justify-content-end align-items-center pe-3 gap-3">
                  <div class="text-center" style="padding-right: 3.5rem;">Đơn giá</div>
                  <div class="col-3 quantity d-none d-xl-table-cell d-lg-table-cell mx-0 my-auto text-center">Số lượng
                  </div>
                  <div class="col-2 subtotal d-none d-xl-table-cell d-lg-table-cell mx-0 my-auto text-center">Thành tiền
                  </div>
                </div>
              </div>

              <!-- CART ITEMS -->
              <ng-container *ngIf="cart.items.length > 0 else noData">
                <div *ngFor="let cartItem of cart.items" class="d-flex flex-column m-3 border rounded shadow-sm">
                  <!-- Voucher suggestion banner -->
                  <div class="d-flex gap-2 align-items-center cursor-pointer"
                    style="padding: 8px 12px"
                    [style]="
                      'color:' + (cartItem.potentialVouchers[0].percentComplete < 100 ? '#FF5D17' : '#389E0D') + '; ' +
                      'background-color: ' + (cartItem.potentialVouchers[0].percentComplete < 100 ? '#FFF2E8' : '#F6FFED') + ' !important;'"
                      *ngIf="cartItem.potentialVouchers && cartItem.potentialVouchers.length > 0"
                      (click)="selectVoucher(cartItem.potentialVouchers[0])" data-cta="cart.item_voucher" data-cta-loc="cart"
                    >
                    <img [src]="cartItem.potentialVouchers[0].percentComplete < 100 ? 'assets/svg/product/voucher.svg' : 'assets/svg/product/voucher-green.svg'" alt="Voucher Icon"  loading="lazy" />
                    <div class="d-flex flex-column gap-2 w-100">
                      <span *ngIf="cartItem.potentialVouchers[0].percentComplete < 100">
                        {{ cartItem.potentialVouchers[0].voucherDescription || cartItem.potentialVouchers[0].voucherCode }}
                      </span>
                      <span *ngIf="cartItem.potentialVouchers[0].percentComplete == 100">
                        Chúc mừng! Bạn đã đạt đủ điều kiện sử dụng voucher "{{ cartItem.potentialVouchers[0].voucherDescription || cartItem.potentialVouchers[0].voucherCode }}"
                      </span>
                      <div class="progress" *ngIf="cartItem.potentialVouchers[0].percentComplete < 100"
                        style="height: 8px !important; background-color: #FF5D1733 !important;">
                        <div class="progress-bar" role="progressbar"
                          [style]="'width:' + cartItem.potentialVouchers[0].percentComplete + '%; height: 8px !important; background-color: #FF5D17 !important;'">
                        </div>
                      </div>
                    </div>
                    <div class="p-2 cursor-pointer"
                      (click)="applyVoucher(cartItem.potentialVouchers[0].voucherCode); $event.stopPropagation()"
                      style="color: white; background-color: #389E0D; border-radius: 8px; text-wrap: nowrap; min-width: 124px; font-weight: 600;"
                      *ngIf="cartItem.potentialVouchers[0].percentComplete == 100 && !cart.voucherDiscounts[cartItem.potentialVouchers[0].voucherCode]"
                    >
                      Áp dụng voucher
                    </div>
                    <div class="p-2"
                      (click)="$event.stopPropagation()"
                      style="cursor: default; color: #389E0D; border: 1px solid #389E0D; border-radius: 8px; text-wrap: nowrap; min-width: 124px; text-align: center; font-weight: 600;"
                      *ngIf="cartItem.potentialVouchers[0].percentComplete == 100 && cart.voucherDiscounts[cartItem.potentialVouchers[0].voucherCode]"
                    >
                      ✓ Đã áp dụng
                    </div>
                  </div>
                  <!-- Product Card Content -->
                  <div class="d-flex align-items-center border-bottom gap-3">
                    <div class="py-3 ps-3 pe-2 border-end">
                      <input [id]="cartItem.productID" class="checkbox_animated chk" type="checkbox"
                        (click)="selectCheckbox(cartItem)" [checked]="cartItem.isSelected" />
                    </div>
                    <div class="flex-grow-1 d-flex flex-column justify-content-center gap-1 my-2">
                      <div class="d-flex align-items-center gap-3">
                        <a *ngIf="cartItem.slug" [routerLink]="'/product/' + cartItem.slug" class="link"
                          title="{{ cartItem.name }}">
                          <div>{{ cartItem.name }}</div>
                        </a>
                        <a *ngIf="!cartItem.slug" [routerLink]="'/product/' + cartItem.productID" class="link"
                          title="{{ cartItem.name }}">
                          <div>{{ cartItem.name }}</div>
                        </a>
                        <!-- <div *ngIf="cartItem.coinIconLevel > 0" class="coin-markup" [class]="'coin-' + cartItem.coinIconLevel" [id]="'coin-markup-' + cartItem.productID">
                          <img [src]="'assets/svg/gift/coin_' + cartItem.coinIconLevel + '.svg'" style="width: 20px; height: 20px;"  loading="lazy" />
                        </div> -->
                      </div>
                      <div *ngIf="cartItem.packagingSpecifications" style="font-size: 11px; width: fit-content; color: #6E6E72; font-weight: 500;">
                        {{ cartItem.packagingSpecifications }}
                      </div>
                    </div>
                    <div class="d-flex justify-content-end p-3 border-start">
                      <button class="border-0 bg-none p-0" (click)="openModal(cartItem)">
                        <img src="assets/svg/cart/trash.svg"  loading="lazy" />
                      </button>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="product-detail col-lg-4 col-xl-4 col-xxl-4 col-md-12 col-xs-12 my-auto mx-0 p-3 col-12">
                      <div class="product border-0 d-flex gap-2">
                        <div>
                          <a *ngIf="!cartItem.slug" [routerLink]="'/product/' + cartItem.productID"
                            class="product-image">
                            <img [src]="
                                cartItem.imgUrl
                                  ? cartItem.imgUrl
                                  : 'assets/images/product.png'
                              " class="img-mobile" alt="{{ cartItem.name }}" title="{{ cartItem.name }}"  loading="lazy" />
                          </a>
                          <a *ngIf="cartItem.slug" [routerLink]="'/product/' + cartItem.slug" class="product-image">
                            <img [src]="
                                cartItem.imgUrl
                                  ? cartItem.imgUrl
                                  : 'assets/images/product.png'
                              " class="img-mobile" alt="{{ cartItem.name }}" title="{{ cartItem.name }}"  loading="lazy" />
                          </a>
                        </div>
                        <div class="product-detail w-100 ms-4 m-auto d-flex" style="min-width: 164.04px;">
                          <ng-container *ngTemplateOutlet="mobileContent; context: { $implicit: cartItem }"></ng-container>
                          <ng-template #mobileContent let-cartItem>
                            <ul class="d-flex flex-column gap-2">
                              <li>
                                <div *ngIf="!cartItem.hasProductVoucher && cartItem.beforeApplyDiscountPrice < cartItem.basePrice">
                                  <img [src]="'assets/svg/tags/promo.svg'"  loading="lazy" />
                                </div>
                                <div *ngIf="cartItem.hasProductVoucher">
                                  <img [src]="'assets/svg/tags/promo-tag-orange.svg'"  loading="lazy" />
                                </div>
                              </li>
                              <li *ngIf="cartItem.expiredDate;" class="me-auto">
                                <div class="product-label expired tag-label">
                                  <span>{{ cartItem.expiredDate }}</span>
                                </div>
                              </li>
                              <li class="d-lg-none d-xl-none d-xxl-none d-flex flex-column w-100" [class.gap-2]="cartItem.variantItems?.length > 1">
                                <ng-container *ngFor="let variant of cartItem.variantItems; let i = index">
                                  <div *ngIf="variant.price < variant.basePrice">
                                    <div class="theme-color">
                                      Giá Khuyến Mãi <span *ngIf="cartItem.variantItems.length > 2">{{i + 1}}</span>
                                    </div>
                                    <div style="font-size: 14px; color: #CF1322; font-weight: 600;">
                                      <span class="text-theme">{{variant.originalQuantity}} x </span>
                                      {{ variant.price | currencySymbol }}
                                    </div>
                                  </div>
                                </ng-container>
                                <div *ngIf="cartItem.variantItems?.length > 1">
                                  <span style="color: #222222;">
                                    Giá gốc:
                                  </span>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                  <span *ngIf="cartItem.price == cartItem.basePrice && cartItem.variantItems?.length > 1" class="text-theme">{{cartItem.originalQuantity}} x &nbsp;</span>
                                  <span *ngIf="cartItem.price == cartItem.basePrice" style="font-weight: 600; color: #CF1322;">
                                    {{ cartItem.basePrice | currencySymbol }}
                                  </span>
                                  <ng-container *ngIf="cartItem.price < cartItem.basePrice">
                                    <del style="color: #6E6E72;">
                                      {{ cartItem.basePrice | currencySymbol }}
                                    </del>
                                    <span style="font-size: 14px; color: #CF1322; font-weight: 400;">
                                      {{ -Math.max(0.01, (cartItem.basePrice - cartItem.price) / cartItem.basePrice) |
                                      percent:'1.0-0' }}
                                    </span>
                                  </ng-container>
                                </div>
                              </li>
                              <!-- VAT label (mobile) -->
                              <li *ngIf="cartItem.vat > 0 && cartItem.basePrice > 0" class="d-lg-none d-xl-none d-xxl-none">
                                <span style="font-size: 11px; color: #888888; font-style: italic;">*Giá đã bao gồm {{ cartItem.vat }}% VAT</span>
                              </li>
                              <li class="d-lg-none d-xl-none d-xxl-none d-block align-items-center pt-3 mt-2 border-top w-100"
                                *ngIf="cartItem.price <= cartItem.basePrice && cartItem.basePrice > 0">
                                <div>Thành tiền</div>
                                <div class="theme-color fw-bold">
                                  {{ cartItem.price * cartItem.quantity | currencySymbol }}
                                </div>
                              </li>
                              <li class="d-lg-none d-xl-none d-flex gap-2 my-2 w-100" *ngIf="cartItem.tieredPrices?.[0] as items">
                                <div *ngIf="(cartItem.appliedPricingTable && cartItem.appliedPricingTable.subType == 0 || cartItem.variantItems?.length > 1) && cartItem.currentSellingPercent != 0" class="progress-bar-width w-100">
                                  <div class="progress">
                                    <div class="progress-bar" role="progressbar" [style]="'width:' + (cartItem.currentTier.remainingQuantity <= 100 ? 50 : cartItem.currentSellingPercent) + '%;'"></div>
                                    <div class="text-white m-auto mobile" style="font-size: 12px; font-weight: 700; line-height: 16px; text-transform: uppercase; z-index: 1;">
                                      {{ cartItem.progressLabel }}
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li *ngIf="cartItem.basePrice > 0" class="d-lg-none d-xl-none d-flex gap-3 align-items-center w-100">
                                <div class="input-group">
                                  <app-counter [cartItem]="cartItem" [btnClass]="'btn-counter'"></app-counter>
                                </div>
                              </li>
                              <li class="d-lg-none d-xl-none theme-color d-flex flex-column w-100" style="gap: 12px; align-items: center;"
                                *ngIf="cartItem.basePrice <= 0">
                                <span class="out-of-stock-text" style="color: red;" *ngIf="cartItem.stockStatus != 8 && cartItem.stockStatus != 10">Sản phẩm tạm thời hết hàng</span>
                                <span class="out-of-stock-text" style="color: red;" *ngIf="cartItem.stockStatus == 8">Vui lòng xác minh hồ sơ kinh doanh để đặt hàng</span>
                                <span class="out-of-stock-text" style="color: red;" *ngIf="cartItem.stockStatus == 10">Sản phẩm này không nằm trong phạm vi kinh doanh GPP của bạn</span>
                                <div style="height: 1px; width: 100%; background-color: #DEE2E6;"></div>
                                <button class="alternativesBtn" (click)="onViewAlternatives(cartItem)" data-cta="cart.alternatives" data-cta-loc="cart"
                                  *ngIf="cartItem.productAlternatives != null && cartItem.productAlternatives.length > 0 && cartItem.basePrice <= 0">
                                  Xem sản phẩm thay thế
                                  <img [src]="'assets/svg/alter-prod/arrow-right-small.svg'" alt="icon" class="object-fit-contain item-img arrow"  loading="lazy" />
                                </button>
                              </li>
                            </ul>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                    <div class="p-3 col-8 d-xl-block d-lg-block d-xxl-block d-none">
                      <div class="product-box-contain d-flex w-100 gap-3 justify-content-end h-100">
                        <ng-container *ngTemplateOutlet="content; context: { $implicit: cartItem }"></ng-container>
                      </div>
                    </div>
                  </div>
                  <ng-template #content let-cartItem>
                    <div class="d-flex justify-content-end gap-3 col-12">
                      <div class="d-lg-none d-xl-none d-flex justify-content-between align-items-center">
                        <div class="p-2 d-flex mt-2 gap-3 flex-wrap">
                          <ng-container>
                            <div *ngIf="cartItem.productOrderLimit?.maxOrderQuantityPerOrder??0 > 0">
                              <h6>Tối đa {{ cartItem.productOrderLimit?.maxOrderQuantityPerOrder }} sản phẩm trên
                                đơn</h6>
                            </div>
                            <div *ngIf="cartItem.productOrderLimit?.maxOrderQuantityPerDay??0 > 0">
                              <h6>Tối đa {{ cartItem.productOrderLimit?.maxOrderQuantityPerDay }} sản phẩm trong
                                ngày</h6>
                            </div>
                          </ng-container>
                        </div>
                        <div class="quantity-price div-col pt-2 d-lg-block d-md-block"
                          style="min-height: auto; max-width: 50%;"
                          *ngIf="cartItem.basePrice > 0 && (cartItem.stockStatus ?? 0) < 8">
                          <div class="qty-box w-100 mt-0">
                            <div class="input-group">
                              <app-counter [cartItem]="cartItem" [btnClass]="'btn-counter'" style="width: 100%"></app-counter>
                            </div>
                          </div>
                          <div class="d-lg-none d-xl-none d-flex justify-content-center pt-2"
                            *ngIf="cartItem.wholesalePriceInfo && cartItem.wholesalePriceInfo.minQuantity > cartItem.quantity">
                            <img class="pe-1" src="assets/svg/warning-3.svg"  loading="lazy" />
                            <span class="text-danger" style="font-size: 12px;">Mua thêm
                              {{cartItem.wholesalePriceInfo.minQuantity - cartItem.quantity}} để được giá {{
                              cartItem.wholesalePriceInfo.wholesalePrice | currencySymbol }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="price d-none d-xl-table-cell d-lg-table-cell mx-0 my-auto">
                        <div *ngIf="cartItem.giftExchangeInfo" class="theme-color text-end fw-bolder">
                          X{{cartItem.quantity}}
                        </div>
                        <div class=""
                          *ngIf="!cartItem.giftExchangeInfo && cartItem.basePrice > 0 && cartItem.stockStatus != 8">
                            <div class="price d-flex justify-content-end align-items-center gap-1">
                              <table class="table">
                                <ng-container *ngFor="let variant of cartItem.variantItems; let i = index">
                                  <tr *ngIf="variant.price < variant.basePrice">
                                    <td class="text-end">
                                      <span style="color: #222222;">
                                        Giá Khuyến Mãi <span *ngIf="cartItem.variantItems.length > 2">{{i + 1}}</span>
                                      </span>
                                    </td>
                                    <td class="text-end fw-bold">
                                      <span class="px-0 text-theme" style="width: 43px;">
                                        {{variant.originalQuantity}}
                                      </span>
                                      <span class="text-theme">x</span>
                                    </td>
                                    <td class="text-end">
                                      <span style="font-size: 14px; font-weight: 600; color: #CF1322;">{{ variant.price | currencySymbol }}</span>
                                    </td>
                                    <!-- <td style="width: 50px;"></td> -->
                                  </tr>
                                </ng-container>
                                <tr>
                                  <td class="text-end">
                                    <span *ngIf="cartItem.variantItems?.length > 1" style="color: #222222;">
                                      Giá gốc
                                    </span>
                                  </td>
                                  <td class="text-end fw-bold">
                                    <ng-container *ngIf="cartItem.price == cartItem.basePrice && cartItem.variantItems?.length > 1">
                                      <span class="px-0 text-theme" style="width: 43px;">
                                        {{cartItem.originalQuantity}}
                                      </span>
                                      <span class="text-theme">x</span>
                                    </ng-container>
                                  </td>
                                  <td class="text-end">
                                    <span *ngIf="cartItem.price == cartItem.basePrice" style="font-size: 14px; font-weight: 600; color: #CF1322;">
                                      {{ cartItem.basePrice | currencySymbol }}
                                    </span>
                                    <del *ngIf="cartItem.price < cartItem.basePrice" style="font-size: 14px; font-weight: 400; color: #6E6E72;">
                                      {{ cartItem.basePrice | currencySymbol }}
                                    </del>
                                  </td>
                                  <td>
                                    <span
                                      *ngIf="cartItem.price < cartItem.basePrice"
                                      style="font-size: 12px; color: #CF1322; font-weight: 400;">
                                      {{ -Math.max(0.01, (cartItem.basePrice - cartItem.price) / cartItem.basePrice) |
                                      percent:'1.0-0' }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </div>
                        </div>
                        <div *ngIf="(cartItem.appliedPricingTable && cartItem.appliedPricingTable.subType == 0 || cartItem.variantItems?.length > 1) && cartItem.basePrice > 0 && cartItem.currentSellingPercent != 0 && cartItem.stockStatus != 8" class="my-2 ms-auto progress-bar-width">
                          <div class="progress">
                            <div class="progress-bar" role="progressbar" [style]="'width:' + (cartItem.currentTier!.remainingQuantity <= 100 ? 50 : cartItem.currentSellingPercent) + '%;'"></div>
                            <div class="text-white m-auto mobile" style="font-size: 12px; font-weight: 700; line-height: 16px; text-transform: uppercase; z-index: 1;">
                              {{ cartItem.progressLabel }}
                            </div>
                          </div>
                        </div>
                        <div *ngIf="cartItem.vat > 0 && cartItem.basePrice > 0" class="text-end mt-1">
                          <span style="font-size: 12px; color: #888888; font-style: italic;">*Giá đã bao gồm {{ cartItem.vat }}% VAT</span>
                        </div>
                      </div>
                      <div class="col-3 quantity d-none d-xl-table-cell d-lg-table-cell mx-0 my-auto"
                        *ngIf="cartItem.basePrice > 0 && (cartItem.stockStatus ?? 0) < 8">
                        <div class="quantity-price div-col justify-content-center" *ngIf="!cartItem.giftExchangeInfo">
                          <div class="qty-box w-100 mt-0">
                            <div style="text-align: center">
                              <ng-container>
                                <div class="d-flex gap-1 d-none d-xl-flex d-lg-flex flex-wrap px-2 py-1 mt-2 gap-3 "
                                  *ngIf="cartItem.productOrderLimit?.maxOrderQuantityPerOrder??0 > 0">
                                  <span>Tối đa {{ cartItem.productOrderLimit?.maxOrderQuantityPerOrder }} sản phẩm
                                    trên
                                    đơn</span>
                                </div>
                                <div class="d-flex gap-1 d-none d-xl-flex d-lg-flex flex-wrap px-2 py-1 mt-2 gap-3"
                                  *ngIf="cartItem.productOrderLimit?.maxOrderQuantityPerDay??0 > 0">
                                  <span>Tối đa {{ cartItem.productOrderLimit?.maxOrderQuantityPerDay }} sản phẩm
                                    trong
                                    ngày</span>
                                </div>
                              </ng-container>
                            </div>
                            <div class="input-group justify-content-center">
                              <app-counter [cartItem]="cartItem" [btnClass]="'btn-counter'"></app-counter>
                            </div>
                            <div class="d-flex"
                              *ngIf="cartItem.wholesalePriceInfo && cartItem.wholesalePriceInfo.minQuantity > cartItem.quantity">
                              <img class="pe-1" src="assets/svg/warning-3.svg"  loading="lazy" />
                              <span class="text-danger" style="font-size: 12px;">Mua thêm
                                {{cartItem.wholesalePriceInfo.minQuantity - cartItem.quantity}} để được giá {{
                                cartItem.wholesalePriceInfo.wholesalePrice | currencySymbol }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 subtotal d-none d-xl-table-cell d-lg-table-cell mx-0 my-auto"
                        *ngIf="cartItem.basePrice > 0 && (cartItem.stockStatus ?? 0) < 8">
                        <div class="mobile div-col" style="justify-content: space-between; gap: 0.5rem;"
                          *ngIf="!cartItem.giftExchangeInfo">
                          <span class="theme-color flex-grow-1 text-end fw-bold">
                            {{
                            cartItem.totalVariantPrice | currencySymbol
                            }}
                          </span>
                        </div>
                      </div>

                      <div colspan="2" class="quantity col-5 d-none d-lg-table-cell d-xl-table-cell text-center mx-0 my-auto"
                        *ngIf="cartItem.basePrice <= 0">
                        <div class="out-of-stock-label div-col d-flex flex-column" style="gap: 12px; align-items: flex-end;" *ngIf="!cartItem.giftExchangeInfo">
                          <span class="out-of-stock-text" style="color: red;" *ngIf="cartItem.stockStatus != 10 && cartItem.stockStatus != 8">Sản phẩm tạm thời hết hàng</span>
                          <span class="out-of-stock-text" style="color: red;" *ngIf="cartItem.stockStatus == 8">Vui lòng xác minh hồ sơ kinh doanh để đặt hàng</span>
                          <span class="out-of-stock-text" style="color: red;" *ngIf="cartItem.stockStatus == 10">Sản phẩm này không nằm trong phạm vi kinh doanh GPP của bạn</span>
                          <button class="alternativesBtn" (click)="onViewAlternatives(cartItem)" data-cta="cart.alternatives" data-cta-loc="cart"
                            *ngIf="cartItem.productAlternatives != null && cartItem.productAlternatives.length > 0 && cartItem.basePrice <= 0">
                            Xem sản phẩm thay thế
                            <img [src]="'assets/svg/alter-prod/arrow-right-small.svg'" alt="icon" class="object-fit-contain item-img arrow"  loading="lazy" />
                          </button>
                        </div>
                      </div>
                      <div colspan="2"
                        class="quantity col-5 d-none d-lg-table-cell d-xl-table-cell text-center mx-0 my-auto"
                        *ngIf="cartItem.basePrice > 0 && (cartItem.stockStatus == 8 || cartItem.stockStatus == 10)">
                        <div class="out-of-stock-label div-col" *ngIf="!cartItem.giftExchangeInfo">
                          <span class="out-of-stock-text" style="color: red;" *ngIf="cartItem.stockStatus == 8">Vui lòng xác minh hồ sơ kinh doanh để đặt hàng</span>
                          <span class="out-of-stock-text" style="color: red;" *ngIf="cartItem.stockStatus == 10">Sản phẩm này không nằm trong phạm vi kinh
                            doanh GPP của bạn</span>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </ng-container>
              <ng-template #noData>
                <div class="d-flex justify-content-center align-items-center pt-5">
                  <span class="text-content" style="font-size: 14px; line-height: 120%; color: #868686;">Giỏ hàng hiện
                    đang trống. Hãy thêm sản phẩm để mua ngay!</span>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="d-grid gap-4 pt-3">
            <!-- TRANSPORT METHOD -->
            <div id="transport-method-section" class="d-grid gap-3 p-3 div-section" *ngIf="transportMethods?.length">
              <div class="d-flex justify-content-between" style="width: 100%;">
                <h4 class="fw-medium">Hình thức vận chuyển</h4>
                <div class="text-error" *ngIf="!isSelectedTransportMethod">Chưa chọn hình thức vận chuyển</div>
              </div>
              <div *ngIf="transportMethods.length > 1"
                class="d-flex justify-content-between align-items-center"
                style="
                  width: 100%;
                  background: radial-gradient(74.62% 187.26% at 35.14% -25%, #0A7F64 0%, #000000 100%);
                  color: white;
                  padding: 0.75rem 1rem;
                  font-weight: 600;
                  border-radius: 12px;
                  font-size: 14px;
                  "
              >
                <div>
                  Hiện giờ bạn đã có nhiều sự lựa chọn hơn trong việc lựa chọn đơn vị vận chuyển
                </div>
                <img [src]="'assets/svg/payment/information.svg'" loading="lazy" />
              </div>
              <div class="d-grid gap-3 radio-transport-options-grid">
                <div class="form-check div-radio-border justify-content-between"
                  [class.active]="selectedTransportMethod && selectedTransportMethod.code == transport?.code"
                  *ngFor="let transport of transportMethods"
                  (click)="changeTransportMethod(transport)" [attr.data-cta]="'cart.shipping_method:' + transport?.code" data-cta-loc="cart">
                  <div class="form-check-label d-flex flex-column gap-1">
                    <div class="text-title d-flex align-items-center gap-2">
                      <div>
                        {{ transport?.name }}
                      </div>
                      @if (transport.paymentMethod && transport.paymentMethod.length) {
                        <div class="d-flex align-items-center gap-1">
                          @for (item of transport.paymentMethod; track item.code ) {
                            @if (selectedTransportMethod && selectedTransportMethod.code == transport?.code) {
                              <img width="16" height="16" [src]="getIconActivePayment(item.code)" loading="lazy" />
                            } @else {
                              <img width="16" height="16" [src]="getIconPayment(item.code)" loading="lazy" />
                            }
                          }
                        </div>
                      }
                    </div>
                    <div class="text-description" *ngIf="transport.estimatedDeliveryTime">{{ transport.estimatedDeliveryTime }}</div>
                    <div class="text-description" *ngIf="transport.description">{{ transport?.description }}</div>
                  </div>
                  <div class="text-title" style="font-size: 14px;">
                    {{ (shipValue ?? 0) > 0 ? (shipValue | currencySymbol) : 'Miễn phí' }}
                  </div>
                </div>
              </div>
            </div>
            <!-- SHIPPING OPTIONS BUT NO LONGER USED -->
              <!-- <div class="d-grid gap-3 p-3 div-section" *ngIf="shippingOptions.length">
                <h4 class="fw-medium border-bottom">Lựa chọn thời gian giao hàng</h4>
                <div class="d-grid gap-3 radio-options-grid">
                  <div class="form-check div-radio-border"
                      [class.active]="selectedShippingOption?.codeDelivery === option.codeDelivery"
                      *ngFor="let option of shippingOptions">
                    <input class="form-check-input"
                          type="radio"
                          name="shippingOption"
                          [id]="option.codeDelivery"
                          [checked]="selectedShippingOption?.codeDelivery === option.codeDelivery"
                          (change)="onSelectShipping(option)" />
                    <label class="form-check-label w-100" [for]="option.codeDelivery">
                      <div class="fw-medium">{{ option.name }}</div>
                    </label>
                  </div>
                </div>
              </div> -->
              <!-- PAYMENT METHOD -->
              <div class="d-grid gap-3 p-3 div-section"
                  *ngIf="dumpDataPayment.length && transportMethods.length">
                <div class="d-flex justify-content-between" style="width: 100%;">
                  <h4 class="fw-medium">Phương thức thanh toán</h4>
                  <div class="text-error" *ngIf="!isSelectedPaymentMethod">Chưa chọn phương thức thanh toán</div>
                </div>
                <div class="d-grid gap-3 radio-options-grid">
                  <div class="form-check div-radio-border"
                    [class.active]="selectedPaymentMethod && selectedPaymentMethod?.code === method.code"
                    [class.disabled]="method.disable"
                    *ngFor="let method of dumpDataPayment"
                    (click)="changePaymentMethod(method)" [attr.data-cta]="'cart.payment_method:' + method.code" data-cta-loc="cart"
                    >
                    <div class="d-flex gap-3 align-items-center">
                      <img
                        width="24"
                        height="24"
                        [src]="
                          method.disable
                            ? method.iconDisabled
                            : selectedPaymentMethod?.code === method.code
                              ? method.iconActive
                              : method.icon
                        "
                       loading="lazy" />
                      <div class="form-check-label d-flex flex-column gap-1">
                        <div class="text-title">{{ method.name }}</div>
                        <div class="text-description" *ngIf="method.description"
                          [class.text-error]="method.disable"
                        >
                          {{
                            method.disable
                              ?
                              selectedTransportMethod
                                ? 'Không áp dụng hình thức vận chuyển ' + selectedTransportMethod.name + '. Hãy đổi sang hình thức vận chuyển khác để sử dụng phương thức thanh toán này.'
                                : 'Vui lòng chọn hình thức vận chuyển trước!'
                              : method.description
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <div class="d-grid gap-3 p-3 div-section">
              <h4 class="fw-medium">Ghi chú giao hàng</h4>
              <textarea id="note" class="form-control"
                placeholder="Thêm ghi chú về đơn hàng để được hỗ trợ (ví dụ: Hãy gọi điện trước khi giao hàng)"></textarea>
            </div>

            <!-- SAVE ORDER TEMPLATE SECTION -->
            <div class="div-section p-3 template-save-card">
              <div class="template-header">
                <input
                  type="checkbox"
                  id="saveOrderTemplate"
                  [(ngModel)]="isSaveOrderTemplate"
                  (change)="onToggleSaveOrderTemplate()"
                  class="checkbox_animated m-0"
                />
                <label for="saveOrderTemplate" class="template-title">
                  Thêm vào đơn hàng thường xuyên
                </label>
              </div>
              <p class="template-desc">
                Lưu vào Đơn hàng thường xuyên để dễ dàng đặt lại khi bạn thường xuyên mua cùng sản phẩm với số lượng và chủng loại cố định.
              </p>
              <div class="template-input-wrapper" *ngIf="isSaveOrderTemplate">
                <label for="orderTemplateName" class="template-input-label">Tên đơn hàng</label>
                <input
                  type="text"
                  id="orderTemplateName"
                  class="form-control template-name-input"
                  [(ngModel)]="orderTemplateName"
                  placeholder="Đơn hàng thường xuyên mới"
                  maxlength="150"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-4 col-xl-4 total mobile-p-0">
          <div class="summary-box p-sticky div-section">
            <div class="summary-header" style="font-size: 20px; font-weight: 600;">
              <span>Thông tin đơn hàng</span>
            </div>

            <div style="border-top: 1px solid #DEE2E6;"></div>

            <div class="summary-contain">
              <div class="d-flex justify-content-between align-items-center">
                <span class="cart-info-text">Số lượng hàng</span>
                <span class="cart-info-text">{{ totalQuantity }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="cart-info-text">Giá gốc</span>
                <span class="cart-info-text">{{ cart.sumTotalPrice | currencySymbol }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="cart-info-text">Giảm giá trực tiếp</span>
                <span class="cart-info-text">{{ cart.sumPriceSavingAmount > 0 ? (-cart.sumPriceSavingAmount | currencySymbol) : (0 | currencySymbol) }}</span>
              </div>

              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-1">
                  <span class="cart-info-text-black" style="font-weight: 500;">Giá trị đơn hàng</span>
                  <div class="position-relative tooltip-icon">
                    <img src="assets/svg/cart/info-circle.svg"  loading="lazy" />
                    <div #tooltip class="tooltip-container">
                      <div class="triangle"></div>
                      <div class="tooltip-content">
                        <ul>
                          <li>Giá trị đơn hàng là tổng tiền các sản phẩm sau khi đã giảm giá trực tiếp.</li>
                          <li>Đây là giá trị đơn được dùng để xác định bạn có đủ điều kiện áp dụng Freeship hoặc Voucher hay không.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <span class="cart-info-text-black" style="font-weight: 500;">{{ cart.sumTotalPrice - (cart.sumPriceSavingAmount || 0) | currencySymbol }}</span>
              </div>

              <div *ngIf="freeShipMessage && shipValue == 0" class="d-flex align-items-center gap-2 bg-green" style="padding: 8px 12px;">
                <img src="assets/svg/cart/check-circle.svg"  loading="lazy" />
                <span class="cart-info-text-black">{{ freeShipMessage }}</span>
              </div>

              <div *ngIf="freeShipMessage && shipValue != 0" class="d-flex align-items-center gap-2 bg-orange" style="padding: 8px 12px;">
                <img src="assets/svg/cart/exclamation-circle.svg"  loading="lazy" />
                <span class="cart-info-text-black">{{ freeShipMessage }}</span>
              </div>

              <div *ngIf="additionalRankingCoins && additionalRankingCoins.length > 0 && additionalRankingCoins[0].remainingToNext > 0" class="d-flex align-items-center gap-2 bg-orange" style="padding: 8px 12px;">
                <img src="assets/svg/cart/exclamation-circle.svg"  loading="lazy" />
                <span class="cart-info-text-black">
                  {{additionalRankingCoins[0].nextLabel}} <b>(Đặt thêm {{additionalRankingCoins[0].remainingToNext | currencySymbol}})</b>
                </span>
              </div>

              <div *ngFor="let voucher of suggestedVouchers">

                <!-- Gần đủ (còn thiếu) - Orange -->
                 <div *ngIf="voucher.remainingAmount > 0 || voucher.remainingSku > 0 || voucher.remainingLabelQuantity > 0"
                  class=" bg-orange d-flex align-items-center gap-2"
                  style="justify-content: space-between; padding: 8px 12px;">
                    <div class="d-flex align-items-center gap-2">
                      <img src="assets/svg/cart/exclamation-circle.svg" loading="lazy" />
                      <span class="cart-info-text-black">
                          {{ voucher.textTemplate }}

                        <!-- Chỉ thiếu tiền -->
                        <b *ngIf="voucher.remainingAmount > 0 && voucher.remainingSku === 0 && voucher.remainingLabelQuantity === 0">
                          (Đặt thêm {{ voucher.remainingAmount | currencySymbol }})
                        </b>

                        <!-- Chỉ thiếu SKU -->
                        <b *ngIf="voucher.remainingSku > 0 && voucher.remainingAmount === 0 && voucher.remainingLabelQuantity === 0">
                          (Thêm {{ voucher.remainingSku }} chủng loại sản phẩm)
                        </b>

                        <!-- Chỉ thiếu Label Quantity -->
                        <b *ngIf="voucher.remainingLabelQuantity > 0 && voucher.remainingAmount === 0 && voucher.remainingSku === 0">
                          (Thêm {{ voucher.remainingLabelQuantity }} sản phẩm từ DHG)
                        </b>

                        <!-- Thiếu tiền + SKU -->
                        <b *ngIf="voucher.remainingAmount > 0 && voucher.remainingSku > 0 && voucher.remainingLabelQuantity === 0">
                          (Đặt thêm {{ voucher.remainingAmount | currencySymbol }} và thêm {{ voucher.remainingSku }} chủng loại sản phẩm)
                        </b>

                        <!-- Thiếu tiền + Label -->
                        <b *ngIf="voucher.remainingAmount > 0 && voucher.remainingLabelQuantity > 0 && voucher.remainingSku === 0">
                          (Đặt thêm {{ voucher.remainingAmount | currencySymbol }} và thêm {{ voucher.remainingLabelQuantity }} sản phẩm từ DHG)
                        </b>

                        <!-- Thiếu SKU + Label -->
                        <b *ngIf="voucher.remainingSku > 0 && voucher.remainingLabelQuantity > 0 && voucher.remainingAmount === 0">
                          (Thêm {{ voucher.remainingSku }} chủng loại sản phẩm và {{ voucher.remainingLabelQuantity }} sản phẩm từ DHG)
                        </b>

                        <!-- Thiếu cả 3 -->
                        <b *ngIf="voucher.remainingAmount > 0 && voucher.remainingSku > 0 && voucher.remainingLabelQuantity > 0">
                          (Đặt thêm {{ voucher.remainingAmount | currencySymbol }}, thêm {{ voucher.remainingSku }} chủng loại và {{ voucher.remainingLabelQuantity }} sản phẩm từ DHG)
                        </b>
                      </span>
                    </div>
                    <span class="cart-info-text-orange-1" style="text-decoration: underline; cursor: pointer; white-space: nowrap;"
                      (click)="toggleVoucherDetail(voucher)" data-cta="cart.voucher_suggested_detail" data-cta-loc="cart">
                      Chi tiết
                    </span>
                 </div>

                <!-- Đủ điều kiện - Green -->
                <div *ngIf="voucher.remainingAmount === 0 && voucher.remainingSku === 0 && voucher.remainingLabelQuantity === 0"
                  class="d-flex align-items-center gap-2 bg-green"
                  style="padding: 8px 12px; justify-content: space-between;"
                >
                  <div class="d-flex align-items-center gap-2">
                    <img src="assets/svg/cart/check-circle.svg" loading="lazy" />
                    <span class="cart-info-text-black">
                      {{ voucher.textTemplate }}
                    </span>
                  </div>
                  <span class="cart-info-text-green" style="text-decoration: underline; cursor: pointer; white-space: nowrap;"
                    (click)="applySuggestedVoucher(voucher)" data-cta="cart.voucher_suggested_apply" data-cta-loc="cart">
                    Sử dụng
                  </span>
                </div>
              </div>

              <div *ngIf="priceChangedItems && priceChangedItems.length > 0" class="d-flex align-items-center gap-2 bg-red" style="padding: 8px 12px;">
                <img src="assets/svg/cart/exclamation-circle-red.svg"  loading="lazy" />
                <span class="cart-info-text-black">{{ priceChangedItems.length }} sản phẩm thay đổi giá so với lúc thêm vào giỏ hàng</span>
                <span class="cart-info-text-red" style="text-decoration: underline; cursor: pointer; white-space: nowrap;" (click)="togglePriceDetail()" data-cta="cart.price_detail" data-cta-loc="cart">Xem chi tiết</span>
              </div>

              <div style="border-top: 1px solid #DEE2E6;"></div>

              <div class="summary-contain">
                <div class="d-flex flex-column gap-3">
                  <div class="voucher-container">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center gap-2">
                        <img src="assets/svg/cart/voucher-orange.svg"  loading="lazy" />
                        <span class="cart-info-text-orange-1" style="font-weight: 600;">Voucher</span>
                      </div>
                      <button class="use-voucher" (click)="openVoucherModal()" data-cta="cart.voucher_open" data-cta-loc="cart">
                        Chọn voucher
                      </button>
                    </div>
                    <div class="mt-2">
                            <button
                              class="auto-apply-voucher w-100"
                              style="background: transparent;
                                    border: 1px solid var(--theme-color);
                                    color: var(--theme-color);
                                    font-weight: 500;
                                    padding: 10px 16px;
                                    border-radius: 8px;
                                    transition: all 0.2s ease;"
                              [disabled]="isLoadingAutoApply"
                              (click)="TriggerAutoApplyVoucher()" data-cta="cart.voucher_auto" data-cta-loc="cart">

                              <span *ngIf="isLoadingAutoApply" class="d-flex align-items-center justify-content-center">
                                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                                Đang kiểm tra...
                              </span>

                              <span *ngIf="!isLoadingAutoApply">
                                Tự động áp dụng voucher
                              </span>
                            </button>
                          </div>

                          <ng-container *ngIf="cart.appliedVouchers && cart.appliedVouchers.length > 0">
                            <div style="border-top: 1px solid #DEE2E6;"></div>
                            <div class="d-flex justify-content-between align-items-center w-100"
                              *ngFor="let voucher of cart.appliedVouchers">
                                <div class="d-flex align-items-center gap-2" style="width: 150px;">
                                  <img src="assets/svg/cart/voucher-brand.svg"  loading="lazy" />
                                  <span style="color: var(--theme-color);">{{voucher.code}}</span>
                                </div>
                                <span style="color: var(--theme-color); padding-left: 0.5rem;">x{{voucher.unitsUsed}}</span>
                              <span style="color: var(--theme-color); padding-left: 0.5rem;">
                                <ng-container *ngIf="voucher.discountType !== 2; else coinTemplate">
                                  {{ cart.voucherDiscounts[voucher.code] | currencySymbol }}
                                </ng-container>

                                <ng-template #coinTemplate>
                                  + {{ voucher.discountValue | number }} Xu
                                </ng-template>
                              </span>
                                <img src="assets/svg/cart/times.svg" (click)="deleteVoucher(voucher.code)" data-cta="cart.voucher_remove" data-cta-loc="cart"  loading="lazy" />
                            </div>
                          </ng-container>
                  </div>

                  <!-- <div *ngIf="userWallet" class="coin-container">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center gap-2">
                        <img src="assets/svg/cart/wallet-filled.svg"  loading="lazy" />
                        <span class="cart-info-text-brand" style="font-weight: 600;">Sử dụng {{ userWallet.balance | currencySymbol: false }}</span>
                      </div>
                      <label class="switch" (change)="useWalletCoin()">
                        <input type="checkbox" [checked]="usingWalletCoin">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div> -->

                  <!-- <div class="coin-container">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="cart-info-text">Xu từ đơn hàng</span>
                      <span class="cart-info-text">{{(isExceededMinimumMilestone ? cart.estimatedReceiveTempCoin : 0) | number: '1.0-0'}} Xu</span>
                    </div>

                    <div *ngIf="additionalTempCoins && additionalTempCoins.length > 0">
                      <div
                        *ngFor="let coin of additionalTempCoins"
                        class="d-flex justify-content-between align-items-center"
                        [hidden]="coin.value <= 0"
                      >
                        <span class="cart-info-text">{{ coin.label }}</span>
                        <span class="cart-info-text">
                          {{ (isExceededMinimumMilestone ? coin.value : 0) | number:'1.0-0' }} Xu
                        </span>
                      </div>
                    </div>

                    <div *ngIf="additionalRankingCoins && additionalRankingCoins.length > 0 && additionalRankingCoins[0].value > 0" class="d-flex justify-content-between align-items-center">
                      <span class="cart-info-text">{{additionalRankingCoins[0].label}}</span>
                      <span class="cart-info-text">{{(isExceededMinimumMilestone ? additionalRankingCoins[0].value : 0) | number: '1.0-0'}} Xu</span>
                    </div>

                    <div style="border-top: 1px solid #DEE2E6;"></div>

                    <div class="d-flex justify-content-between align-items-center gap-3">
                      <span class="cart-info-text-brand" style="font-weight: 600;">Số xu dự kiến nhận được</span>
                      <div class="d-flex align-items-center gap-1">
                        <img src="assets/svg/cart/wallet.svg"  loading="lazy" />
                        <span class="cart-info-text-brand" style="font-weight: 600; width: max-content;">
                          {{(isExceededMinimumMilestone ? cart.estimatedReceiveTempCoin : 0) + (isExceededMinimumMilestone && additionalRankingCoins && additionalRankingCoins.length > 0 ? additionalRankingCoins[0].value : 0) + getAdditionalTempCoins() | number: '1.0-0'}} Xu
                        </span>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>

              <div class="d-flex justify-content-between align-items-center">
                <span class="cart-info-text">Giảm giá Voucher</span>
                <span class="cart-info-text">{{ cart.voucherDiscountAmount > 0 ? (-cart.voucherDiscountAmount | currencySymbol) : (0 | currencySymbol) }}</span>
              </div>

              <div *ngIf="cart.appliedCoin" class="d-flex justify-content-between align-items-center">
                <span class="cart-info-text">Sử dụng xu</span>
                <span class="cart-info-text">-{{ cart.appliedCoin | currencySymbol }}</span>
              </div>

              <div class="d-flex justify-content-between align-items-center">
                <span class="ship-value">Phí vận chuyển</span>
                <div *ngIf="shipValue === undefined">
                  <div style="text-align: right;">---</div>
                  <div
                    class="text-danger"
                    style="text-align: right;
                      font-size: 12px; font-style: italic;"
                  >
                    Thiếu địa chỉ nhận hàng
                  </div>
                </div>
                <div class="ship-value" *ngIf="shipValue !== undefined">
                  {{ shipValue === 0 ? 'Miễn phí' : (shipValue | currencySymbol) }}
                </div>
              </div>

              <div class="d-flex justify-content-between align-items-center">
                <span class="cart-info-text-black" style="font-size: 20px; font-weight: 600;">Tổng tiền</span>
                <span class="cart-info-text-brand" style="font-size: 20px; font-weight: 700;">{{ cart.finalPrice + (shipValue || 0) | currencySymbol }}</span>
              </div>

              <div style="border-top: 1px solid #DEE2E6;"></div>

              <div class="d-flex flex-column gap-3">
                <div style="display: flex; align-items: center; gap: 4px;">
                  <input
                    id="agree"
                    [(ngModel)]="isAgreeToTerms"
                    class="checkbox_animated"
                    type="checkbox"
                    style="flex-shrink: 0;"
                  />
                  <label for="agree" style="margin-top: 4px; line-height: 1.5; white-space: normal; word-break: break-word; flex: 1;">
                    Tôi đồng ý với <a href="/dieu-khoan-su-dung" target="_blank">Điều khoản sử dụng</a>
                    và <a href="/chinh-sach-bao-mat" target="_blank">Chính sách bảo mật.</a>
                  </label>
                </div>
                <div style="display: flex; align-items: center; gap: 4px;">
                  <input
                    id="exportInvoice"
                    [(ngModel)]="isExportInvoice"
                    class="checkbox_animated"
                    [class.custom-disabled-checkbox]="isInvoiceForced"
                    type="checkbox"
                    [disabled]="isInvoiceForced"
                    style="flex-shrink: 0;"
                  />

                  <label
                    for="exportInvoice"
                    class="mb-0"
                    [class.cursor-pointer]="!isInvoiceForced"
                    style="margin-top: 4px; line-height: 1.5; white-space: normal; word-break: break-word; flex: 1; display: flex; align-items: center; gap: 6px; flex-wrap: wrap;"
                  >
                    <span>In hóa đơn giấy</span>
                    <img
                      *ngIf="isInvoiceForced"
                      src="assets/svg/cart/info-circle.svg"
                      width="16"
                      height="16"
                      [ngbTooltip]="invoiceTooltip"
                      placement="top"
                      tooltipClass="custom-gray-tooltip"
                     loading="lazy" />
                  </label>
                </div>
                <div *ngIf="isShipmentInOrderEnabled">
                  <input id="stockOutWithoutPrice" [(ngModel)]="isStockOutWithoutPrice" class="checkbox_animated" type="checkbox" />
                  <label for="stockOutWithoutPrice">In kèm Phiếu xuất kho</label>
                </div>
                <button id="bt" class="btn-animation gap-3"
                  [class.btn-checkout]="!isProcessingOrder"
                  [class.btn-disable]="isProcessingOrder"
                  [disabled]="(!cart.items.length && !cart.giftItems.length) || isProcessingOrder"
                  (click)="checkout()" data-cta="cart.checkout" data-cta-loc="cart">
                  <img src="assets/svg/cart/shopping-cart.svg"  loading="lazy" />
                  Đặt hàng
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #gift let-btnClass="btnClass" let-divClass="divClass">
      <div [class]="divClass">
        <button class="btn-gift list" [class]="btnClass" (click)="gotoGiftList()" data-cta="cart.gift_exchange" data-cta-loc="cart">
          <img src="assets/svg/gift/gift.svg" style="width: 20px; height: 20px;"  loading="lazy" />
          <b>Đổi xu lấy quà</b>
        </button>
      </div>
      <div [class]="divClass">
        <button class="btn-gift add" [class]="btnClass" (click)="giftListModal.openModal()" data-cta="cart.gift_add" data-cta-loc="cart">
          <i class="ri-add-line" style="font-size: 20px;"></i>
          <b>Thêm quà vào giỏ</b>
        </button>
      </div>
    </ng-template>
    <ng-template #giftMobile let-btnClass="btnClass" let-divClass="divClass" let-btnStyle="btnStyle" let-btnStyle1="btnStyle1">
      <div [class]="divClass">
        <button class="btn-gift list" [class]="btnClass" [style]="btnStyle" (click)="gotoGiftList()" data-cta="cart.gift_exchange" data-cta-loc="cart">
          <b>Đổi xu lấy quà</b>
        </button>
      </div>
      <div [class]="divClass">
        <button class="btn-gift add" [class]="btnClass" [style]="btnStyle1" (click)="giftListModal.openModal()" data-cta="cart.gift_add" data-cta-loc="cart">
          <b>Thêm quà vào giỏ</b>
        </button>
      </div>
    </ng-template>
  </div>
</section>

<app-confirmation-modal #confirmDeleteModal [message]="confirmDeleteMessage"
  (confirmed)="confirmDelete($event)">
</app-confirmation-modal>

<app-confirmation-address-modal #confirmAddressModal
  [user]="user" (confirmed)="confirmAddress($event)"></app-confirmation-address-modal>


<app-voucher-modal #voucherModal (useVoucher)="applyVoucher($event.code, $event.unitsUsed)" *ngIf="!skeletonLoader"
  [cart]="cart" [selectedCode]="selectedVoucherCode" (confirmed)="onCloseVoucherModal($event)"></app-voucher-modal>
<app-voucher-detail-modal #detailModal [selectedVoucher]="selectedVoucher"
  (closeModalEvent)="closeModalVoucher()"></app-voucher-detail-modal>
<address-modal [address]="addressEdit" [addresses]="addresses" #addressModal (resetAddress)="resetAddress()"
  (resultForm)="addAddressAfterCreate($event)"></address-modal>
<app-addressv2-modal [address]="addressEdit" [addresses]="addresses" #addressV2Modal (resetAddress)="resetAddress()"
  (resultForm)="addAddressAfterCreate($event)"></app-addressv2-modal>
<!-- <app-exchange-gift-modal #exchangeGiftModal [giftList]="giftList" [giftInfo]="giftInfo"
  [cart]="cart"></app-exchange-gift-modal>
<app-exchange-point-gift-modal #exchangePointGiftModal [pointGiftList]="pointGiftList" [pointGiftInfo]="pointGiftInfo"
  [cart]="cart">
</app-exchange-point-gift-modal> -->

<app-gift-list-modal #giftListModal></app-gift-list-modal>
<app-warning-price-chance-modal #priceChangedModal></app-warning-price-chance-modal>
<app-voucher-detail-modal #detailModal [selectedVoucher]="selectedVoucher"></app-voucher-detail-modal>
<app-announce-popup #announceModal
  [imageUrl]="'assets/svg/payment/announce_image.svg'"
  [title]="'Hiện giờ bạn đã có nhiều lựa chọn hình thức vận chuyển hơn'"
  [message]="'Nhằm tạo sự thuận tiện và chủ động hơn cho khách hàng, Dược Vương đã bổ sung thêm các phương thức vận chuyển khác nhau để khách hàng có thể lựa chọn theo nhu cầu cá nhân. Trải nghiệm ngay!'"
  [buttonText]="'Đã hiểu'"
></app-announce-popup>
</div>
}
